/* Combat Commerce — Theme JS */

(function() {
  'use strict';

  /* --- Mobile Menu Toggle --- */
  const menuToggle = document.querySelector('[data-mobile-toggle]');
  const menuClose = document.querySelector('[data-mobile-close]');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      menuToggle.setAttribute('aria-expanded', 'true');
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function() {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- Header Scroll Effect --- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.scrollY;
      if (currentScroll > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Dropdown Menus (Desktop) --- */
  const dropdowns = document.querySelectorAll('.nav__item--dropdown');
  dropdowns.forEach(function(dropdown) {
    let timeout;
    dropdown.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      this.classList.add('is-open');
    });
    dropdown.addEventListener('mouseleave', function() {
      const self = this;
      timeout = setTimeout(function() {
        self.classList.remove('is-open');
      }, 150);
    });
  });

  /* --- Mobile Accordion Submenus --- */
  const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
  accordionTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const parent = this.parentElement;
      const submenu = parent.querySelector('.mobile-menu__sub');
      if (submenu) {
        parent.classList.toggle('is-expanded');
        submenu.style.display = parent.classList.contains('is-expanded') ? 'block' : 'none';
      }
    });
  });

  /* --- Quantity Inputs --- */
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-qty-minus]')) {
      const input = e.target.parentElement.querySelector('input[type="number"]');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
        input.dispatchEvent(new Event('change'));
      }
    }
    if (e.target.matches('[data-qty-plus]')) {
      const input = e.target.parentElement.querySelector('input[type="number"]');
      if (input) {
        input.value = parseInt(input.value) + 1;
        input.dispatchEvent(new Event('change'));
      }
    }
  });

})();
